/**
 * 自定义短信营销-短信模块
 */
 import Form from './Form';
 import utils from '@/common/utils';

 export default {
   data: () => ({
    smsContent: '', // 短信签名
   }),

   validators: {
     smsContent: (val,linkList) => new Promise((resolve, reject) => {
       try {
         if (val.viewButton.secondHalf.addParam.productLineList.length === 0) {
           reject(new Error('请选择商品分组'));
         }
         else {
           resolve();
         }
       } catch (error) {
         throw error;
       }
     }),
   },
   components: {
     Form: Form
   }
 }